export class ProductModel {
    ProductModelID: number;
    ProductModelName: string;
    ProductModelDescription: string;
    ProductRangeID: number;
    ProductRangeName: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}
